import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroup2 from "../../RadioButtonGroup/RadioButtonGroupimpedance/RadioButtonGroup2";
import {Link} from "react-router-dom";

let castellated = [
    {
        id: 1,
        checked: false,
        name: "castellatedHoles",
        text: <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-yes"
                                defaultMessage="Yes"
                                description=""/>
    },
    {
        id: 0,
        checked: true,
        name: "castellatedHoles",
        text: <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-no"
                                defaultMessage="No"
                                description=""/>
    },
];

const CastellatedHoles = (props) => {

    let pcbCastellatedHoles = castellated.map((item) => {
        item.checked = (item.id === props.selectedId);
        return item;
    });

    return (
            <div className="col-md-7 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-5 text-right content-item-heading responsive-castellated">
                        <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes"
                                          defaultMessage="Castellated Holes"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="castlHole-qLink"
                            to={{pathname:"https://kitcutlabo.com/castration/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-7 pcb-details-div-items responsive-castellated">
                        <RadioButtonGroup2 data={pcbCastellatedHoles} getParams={props.setPCBParams}/>
                    </div>
                </div>
            </div>
    )
};

export default CastellatedHoles;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/CastellatedHoles.js